<template>
    <div class="distributor-register-index">
        <!--注册协议-->
        <mt-popup v-model="step1Visible" position="right" class="common-popup-wrapper document">
            <div class="common-header-wrap">
                <mt-header :title="title" class="common-header">
                    <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <div class="content" v-html='content'></div>
            </div>
            <div class="btn-wrapper">
                <div class="btn"><mt-button size="large" type="default" plain @click="$router.go(-1)">{{ $t('general.disagree' )}}</mt-button></div>
                <div class="btn"><mt-button size="large" type="primary" @click="popup(2)">{{ $t('general.agree') }}</mt-button></div>
            </div>
        </mt-popup>

        <!--验证手机-->
        <mt-popup v-model="step2Visible" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header :title="$t('distributor.title.phone_verification')" class="common-header">
                    <mt-button slot="left" icon="back" @click="popup(1)"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
				<div class='main-content'>
					<flex-line class="field-line input-wrapper" :show-border="true">
            <div class="field-line-right" slot="right">
              <input class="field-input" v-model.trim="$v.mobile.$model" :placeholder="$t('placeholder.mobile')" type="number" />
            </div>
          </flex-line>
					<flex-line class="field-line" :show-border="true"><span class="field-name">{{ $t('distributor.login.sms_captcha') }}</span><div class="field-line-right" slot="right"><input class="field-input" v-model="verifyCode" /><div @click="sendVerifyCode" class="common-btn send-btn">{{sendStateText}}</div></div></flex-line>
					<div class="pt-10 pb-10"><div class="common-btn ds-button-large" @click="checkVerifyCode">{{ $t('general.next_step') }}</div></div>
				</div>
            </div>
        </mt-popup>

        <!--创建账号-->
        <mt-popup v-model="step3Visible" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header :title="$t('distributor.title.create_account')" class="common-header">
                    <mt-button slot="left" icon="back" @click="popup(2)"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
				<div class='main-content'>
					<flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" v-model="user_name" :placeholder="$t('distributor.login.input_name')" maxlength="25" /></div></flex-line>
					<flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password" :placeholder="$t('distributor.login.input_password')" maxlength="20" /></div></flex-line>
					<flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password2" :placeholder="$t('distributor.login.input_password_confirm')" maxlength="20" /></div></flex-line>
					<div class="pt-10 pb-10"><div class="common-btn ds-button-large" v-on:click="register">{{ $t('general.enter') }}</div></div>
				</div>
            </div>
        </mt-popup>

    </div>
</template>

<script>
import { getDocumentInfo } from '../../../api/homeArticle'
import { register } from '../../../api/distributorRegister'
import { Indicator, Toast } from 'mint-ui'
import { mapMutations, mapState } from 'vuex'
import { checkVerifyCode,sendVerifyCode } from '../../../api/common'
import flexLine from '../../flexLine'
import { maxLength, minLength, required, sameAs } from 'vuelidate/lib/validators'
import validator from '@src/util/validator'

export default {
	components: {
		  flexLine
	},
  name: 'DistributorRegister',
  data () {
    return {
      step1Visible: true,
      step2Visible: false,
      step3Visible: false,
      title: '',
      content: '',
      mobile: '',
      verifyCode: '',
      canSend: true,
      timeInterval: false,
      sendStateText: this.$t('general.send'),
      user_name: '',
      password: '',
      password2: ''
    }
  },
  validations: {
    mobile: {
      required,
      mobile: validator.mobile
    },
    verifyCode: {
      required,
      maxLength: maxLength(6),
      minLength: minLength(6)
    }
  },
  computed: {
    ...mapState({
      user: state => state.distributor.info
    })
  },
  created: function () {
    Indicator.close()
    getDocumentInfo('o2o_distributor').then(res => {
      this.title = res.result.document_title
      this.content = res.result.document_content
    }).catch(function (error) {
      Toast(error.message)
    })
  },
  beforeDestroy: function () {
    clearInterval(this.timeInterval)
  },
  methods: {
    ...mapMutations({
      distributorLogin: 'distributorLogin'
    }),
    checkVerifyCode () {
      checkVerifyCode(2, 3, this.verifyCode).then(res => {
        this.popup(3)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    popup (step) {
      this.step1Visible = step == 1
      this.step2Visible = step == 2
      this.step3Visible = step == 3
    },
    sendVerifyCode () {
      if (!this.canSend) {
        return
      }
      sendVerifyCode('mobile', 2, 3,this.mobile).then(res => {
        this.canSend = false
        let second = 60
        Toast(res.message)
        let _this = this
        this.timeInterval = setInterval(function () {
          if (second <= 0) {
            _this.canSend = true
            _this.sendStateText = this.$t('general.send')
            clearInterval(_this.timeInterval)
          } else {
            _this.sendStateText = second + 's'
          }

          second--
        }, 1000)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    register () {
      Indicator.open()
      register(
        this.mobile,
        this.verifyCode,
        this.user_name,
        this.password,
        this.password2
      ).then(res => {
        Indicator.close()
        this.distributorLogin({ token: res.result.token, info: res.result.user })
        this.$router.push({ name: 'DistributorInformation', query: { from: 'register' } })
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" >
	.main-content{padding:0 $pageSpace}
    .distributor-register-index{
        .document{
            .common-popup-content{bottom:3rem;
                .content{padding:.5rem;font-size:.7rem;
                    img{max-width:100%}
                }
            }
            .btn-wrapper{position:absolute;bottom:0;display: flex;width:100%;
                .btn{padding:.5rem;flex:1}
            }
        }

    }
    .common-popup-content {
      top: 4rem !important;
    }
</style>
